export default __webpack_public_path__ + "static/media/heart.ae36742a.png";